import Header from "../headerAuthenticated/HeaderAuthenticated.vue"
import ResponsiveFooter from "../responsivefooter/ResponsiveFooter.vue"
import '../../mixins.js'
import ResponsiveHeader from "../responsiveheader/ResponsiveHeader.vue"
import ResponsiveHeaderMobile from "../ResponsiveHeaderMobile/ResponsiveHeaderMobile.vue"
import axios from 'axios'
import CookieLaw from 'vue-cookie-law'
import { setOptions } from 'vue-gtag'
var domain = "https://user.sigmafolio.net/"
export default {
  name: 'data-policy-page',
  components: {
    Header: Header,
    responsivefooter: ResponsiveFooter,
    responsiveheader: ResponsiveHeader,
    responsiveheadermobile: ResponsiveHeaderMobile,
    CookieLaw
  },
  props: [],
  data () {
    return {
      mobileView: true,
      isLoggedIn: false,
      cookiesSet: false,
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    handleView() {
      this.mobileView = window.innerWidth <= 800;
    },
    checkHeader(){
      let accessToken = localStorage.getItem('access-token');
      if (accessToken == null) {
        this.isLoggedIn = false;
      }else{
        axios.post(domain + "api/token/verify/", {
          'token': accessToken
                }
      ).then(response => {
        console.log(response);
        this.isLoggedIn = true;
        }

      ).catch(e => {
        this.isLoggedIn = false;
        console.log(e);

      })
        this.isLoggedIn = true;
      }
    },
    onChangeEventHandler: function (){

      if(this.cookiesSet == true){
        localStorage.setItem('cookie:accepted', true)
        setOptions({
          enabled: true,
        })
        this.$gtag.optIn()
      }else{
          localStorage.setItem('cookie:accepted', false)
          setOptions({
            enabled: false,
          })
          this.$gtag.optOut()
      }
    }
  },
  created(){
    this.checkHeader();
    this.handleView();
    window.addEventListener('resize', this.handleView);
    this.enablePlugin();
    var cookieStatus = localStorage.getItem('cookie:accepted')
    if(cookieStatus == 'true'){
      this.cookiesSet = true;
    }
  },
  
}


